export const NOTIFICATION_TYPE = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
};

export const NOTIFICATION_TYPE_LABELS = {
  [NOTIFICATION_TYPE.INFO]: 'Info',
  [NOTIFICATION_TYPE.SUCCESS]: 'Success',
  [NOTIFICATION_TYPE.WARNING]: 'Warning',
  [NOTIFICATION_TYPE.ERROR]: 'Error',
};

export const NOTIFICATION_CATEGORY = {
  TOURNAMENT: 'Tournament',
  MATCH: 'Match',
  SCORING: 'Scoring',
  SPONSOR: 'Sponsor',
  GALLERY: 'Gallery',
  SYSTEM: 'System',
  USER: 'User',
};

export const NOTIFICATION_CATEGORY_LIST = Object.values(NOTIFICATION_CATEGORY);

export const NOTIFICATION_FILTER_OPTIONS = [
  { value: '', label: 'All' },
  { value: 'false', label: 'Unread' },
  { value: 'true', label: 'Read' },
];

export function formatNotificationTime(value) {
  if (!value) return '';
  const date = new Date(value);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMins = Math.floor(diffMs / 60000);

  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  const diffHours = Math.floor(diffMins / 60);
  if (diffHours < 24) return `${diffHours}h ago`;
  return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}

export function getNotificationTypeStyles(type) {
  switch (type) {
    case NOTIFICATION_TYPE.SUCCESS:
      return 'border-l-success bg-success/5';
    case NOTIFICATION_TYPE.WARNING:
      return 'border-l-warning bg-warning/5';
    case NOTIFICATION_TYPE.ERROR:
      return 'border-l-error bg-error/5';
    default:
      return 'border-l-primary bg-primary/5';
  }
}
